<template>
  <q-layout>
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container v-if="pageLoad">
      <q-page padding>
        <div class="row justify-between">
          <q-btn class="q-ma-xs q-pr-md justify-left" ripple dense flat color="black" @click="dialogExit = true">
            <q-icon name="arrow_left" style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
          <div class="col text-right row justify-end">
            <q-btn ripple icon="cloud_upload" flat color="black" size="20px" @click="dialogUpload = true" />
            <q-btn ripple icon="cloud_download" flat color="black" size="20px" @click="download" />
            <q-btn :disable="farmPopUp" :loading="load" ripple icon="save" flat color="black" @click="dialogSubmit = true" size="20px"/>
          </div>
        </div>
        <div class="text-h5 text-center q-py-md">Kế hoạch kỳ {{modelForShow.tag ? modelForShow.tag.substr(modelForShow.tag.length-1, 1)
          : genNextTag('ky') }}
          tháng {{modelForShow.tag ? parseInt(modelForShow.tag.substr(modelForShow.tag.length-3, 2)) : genNextTag('M')}}
          năm {{modelForShow.tag ? parseInt(modelForShow.tag.substr(0, 4)) :genNextTag('YYYY')}}</div>
        <q-card class="q-my-xs q-pa-md" >
          <span class="text-h6 ">Bộ lọc :</span>
            <div class="row">
              <div class="col-12 col-sm q-mx-xs">
                <q-input readonly :value="$getNameById(farmStore.list, modelForShow.farm, 'name')" label="Nông trường" >
                  <template v-slot:prepend>
                    <q-icon name="filter_vintage" />
                  </template>
                </q-input>
              </div>
              <div class="col-12 col-sm q-mx-xs">
                <q-select :readonly="!modelForShow.farm ? true : false" clearable v-model="modelForShow.lot" :options="lots" option-value="id" option-label="name" label="Lô">
                  <template v-slot:prepend>
                    <q-icon name="local_florist" />
                  </template>
                </q-select>
              </div>
              <div class="col-12 col-sm q-mx-xs">
                <q-select multiple clearable :readonly="!modelForShow.lot ? true : false" emit-value v-model="modelForShow.slot" :options="slots" option-value="id" option-label="name" label="Ô" >
                  <template v-slot:prepend>
                    <q-icon name="local_florist" />
                  </template>
                </q-select>
              </div>
            </div>
            <span class="row text-weight-bold q-py-xs">Công việc</span>
            <div class="row">
              <q-select 
              :use-input="job === null"
              @filter="filterJob"
                emit-value clearable class="col-12 col-sm"  v-model="job" :options="jobStore.list" option-value="id" option-label="name" :display-value="$getNameById(jobStore.list, job, 'name')" label="Nội dung công việc">
                <template v-slot:prepend>
                  <q-icon name="pan_tool" />
                </template>
              </q-select>
              <div class="col-12 col-sm-6 q-mr-md row q-pa-xs">
                <div class="col-xs-12 text-grey">Loại</div>
                <div class="col-xs-12 col-sm-11">
                  <q-checkbox v-model="cn" :label="workerTypes[0].label"/>
                  <q-checkbox v-model="ck" :label="workerTypes[1].label"/>
                </div>
              </div>
            </div>
        </q-card>

      <!-- farmPopup -->
      <q-dialog v-model="farmPopUp" persistent>
        <q-card style="width:100vw; max-width:500px">
          <q-card-section>
          <div class="text-h6">Chọn nông trường</div>
        </q-card-section>
          <q-card-section class="row items-center">
            <div class="col q-pa-md">
            <q-select 
            @blur="{}"
            :error="errors.has('farm')"
            data-vv-validate-on="blur|submitEvent"
            :error-message="errors.first('farm')" 
            v-validate="'required'"
            ref = "farm"
            name = "farm"
            clearable emit-value v-model="initFarm" :options="farmStore.list" option-value="id" option-label="name" :display-value="$getNameById(farmStore.list, initFarm ,'name')" label="Nông trường">
              <template v-slot:prepend>
                <q-icon name="filter_vintage" />
              </template>
            </q-select>
            </div>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup to="/plans"/>
            <q-btn ripple flat icon="done"  @click="applyFarm()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>

      <!-- Exit -->
      <q-dialog v-model="dialogExit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar color="black" text-color="white">?</q-avatar>
            <span class="q-ml-sm">Bạn có muốn thoát ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup to="/plans"/>
          </q-card-actions>
        </q-card>
      </q-dialog>

      <!-- Submit Data -->
      <q-dialog v-model="dialogSubmit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="save" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có muốn lưu ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="submitData()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>

        <q-table
          :data="tableData"
          :columns="headers"
          row-key="name"
          no-data-label="Không có dữ liệu"
          :key="tableKey"
          :pagination.sync= pagination
          :hide-bottom="!_.isEmpty(tableData)"
          >
          <template v-slot:top-right="props">
            <q-btn ripple dense icon="add" color="black" flat @click="addItem()" class="q-mr-md"/>
          </template>
          <template v-slot:body ="props">
            <q-tr :props="props" v-if="props.row.deleted !== true">
              <q-td >{{ props.row.__index + 1}}</q-td>
              <q-td v-if="props.colsMap.lot" class="label-xs-right text-center">{{$getNameById(lots, props.row.lotID, 'name')}}</q-td>
              <q-td v-if="props.colsMap.slot" class="label-xs-right text-center">{{props.row.slots}}</q-td>
              <q-td v-if="props.colsMap.job" class="label-xs-right text-center">{{$getNameById(jobStore.list, props.row.jobID, 'name')}}</q-td>
              <q-td v-if="props.colsMap.jobType" class="label-xs-right text-center">{{$getNameById(workerTypes, props.row.jobType, 'label')}}</q-td>
              <q-td v-if="props.colsMap.numOfTask" class="label-xs-right text-center">{{(typeof props.row.numOfTask === 'number' && props.row.numOfTask > 0) ?  props.row.numOfTask.toFixed(2) : props.row.numOfTask }}</q-td>
              <q-td v-if="props.colsMap.quotaTask" class="label-xs-right text-center">{{(typeof props.row.quotaTask === 'number' && props.row.quotaTask > 0) ?  props.row.quotaTask.toFixed(3) : props.row.quotaTask }}</q-td>
              <q-td v-if="props.colsMap.planWeight" class="label-xs-right text-center">{{(typeof props.row.planWeight === 'number' && props.row.planWeight > 0) ?  props.row.planWeight.toFixed(2) : props.row.planWeight }}</q-td>
              <q-td v-if="props.colsMap.unit" class="label-xs-right text-center">{{$getNameById(jobStore.list, props.row.jobID, 'unit')}}</q-td>
              <q-td v-if="props.colsMap.note" class="label-xs-right text-center">{{props.row.note}}</q-td>
              <q-td class="label-xs-right text-center">
                <q-btn ripple flat round color="black" icon="edit" @click="clickEditButton(props)" />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <!-- Edit form -->
    <q-dialog  v-if="dialogEdit" v-model="dialogEdit" persistent :key="dialogKey" >
      <q-card style="width:100vw; max-width:800px">
        <q-card-section>
          <div class="text-h6">Nhập dữ liệu</div>
        </q-card-section>
        <!-- Form render -->
          <q-card-section ref="form">
            <q-select 
            bottom-slots
              @blur="{}"
              :error="errors.has('lot')"
              data-vv-validate-on="blur|submitEvent"
              :error-message="errors.first('lot')" 
              name="lot"
              ref="lot"
              v-validate="{required: true}"
              @click="dialogKey++"
              clearable emit-value v-model="model.lotID" :options="lots" option-value="id" :display-value="$getNameById(lots, model.lotID, 'name')" option-label="name" label="Lô" >
              <template v-slot:prepend>
                <q-icon name="local_florist" />
              </template>
            </q-select>
            <!-- eslint-disable-next-line -->
            <div class="q-pt-md">Ô :</div>
            <div class="row q-py-xs">
              <q-chip class="col-5 col-sm-3 col-md-2" v-for="(item) in model.slots" :key="item.id" :selected.sync="item.picked" :color="!item.picked ? 'grey' : 'primary' " text-color="white" @click="modelKey++" >
                <div class="text-center break-word" style="text-overflow: ellipsis; overflow: hidden;white-space: nowrap;"> {{item.name}} </div>
              </q-chip>
            </div>

            <div class="row q-py-xs" >
              <div class="col-xs-12 col-md-6">
                <q-select
                @blur="{}"
              :error="errors.has('job')"
              data-vv-validate-on="blur|submitEvent"
              :error-message="errors.first('job')" 
              name="job"
              ref="job"
              :use-input="model.jobID === null || model.jobID === undefined"
              @filter="filterJob"
              v-validate="{required: true}"
              clearable emit-value v-model="model.jobID" :options="jobOptions" option-value="id" option-label="name" :display-value="$getNameById(jobStore.list, model.jobID, 'name')" label="Nội dung công việc">
                  <template v-slot:prepend>
                    <q-icon name="pan_tool" />
                  </template>
                </q-select>
                </div>
              <div class="col-xs-12 col-md-6">
                Loại <q-option-group inline v-model="model.jobType" :options="workerTypes"/>
                </div>
            </div>
            

            <q-input
              v-model="model.numOfTask"
              bottom-slots
              @blur="{}"
              :error="errors.has('numOfTask')"
              data-vv-validate-on="blur|submitEvent"
              :error-message="errors.first('numOfTask')" 
              name="numOfTask"
              ref="numOfTask"
              v-validate="{min_value:0, required: true, decimal:true}"
              class="q-pb-lg" label="Số lượng công" >
                <template v-slot:prepend>
                  <q-icon name="fitness_center" />
                </template>
            </q-input>

            <q-input
              v-model="model.planWeight"
              bottom-slots
              @blur="{}"
              :error="errors.has('planWeight')"
              data-vv-validate-on="blur|submitEvent"
              :error-message="errors.first('planWeight')" 
              name="planWeight"
              ref="planWeight"
              v-validate="{min_value:0, required: true, decimal:true}"
              class="q-pb-lg" label="Khối lượng kế hoạch" type="number">
                <template v-slot:prepend>
                  <q-icon name="fitness_center" />
                </template>
            </q-input>

            <q-input
              v-model="model.quotaTask"
              bottom-slots
              @blur="{}"
              :error="errors.has('quotaTask')"
              data-vv-validate-on="blur|submitEvent"
              :error-message="errors.first('quotaTask')" 
              name="quotaTask"
              ref="quotaTask"
              v-validate="{min_value:0, required: true, decimal:true}"
              class="q-pb-lg" label="Định mức (Công/ Ngày)" type="number">
                <template v-slot:prepend>
                  <q-icon name="fitness_center" />
                </template>
            </q-input>
            
            
            <q-input v-model="model.note" filled type="textarea" label="Ghi chú">
              <template v-slot:prepend>
                <q-icon name="create" />
              </template>
            </q-input>
            
          </q-card-section>
          <!-- Functions -->
          <q-card-actions align="right">
            <q-btn v-if="!isAdding" flat ripple round icon="delete" @click="dialogDel = true"/>
            <q-btn ripple flat icon="clear" @click="resetData()" v-close-popup/>
            <q-btn flat ripple icon="done" @click="submitModel()" />
          </q-card-actions>
      </q-card>
            <!-- Delete Record -->
      <q-dialog v-model="dialogDel" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="delete" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có chắc chắn muốn xóa ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="deleteItem()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-dialog>
      <q-dialog v-model="dialogUpload" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="cloud_upload" color="black" text-color="white"/>
            <span class="q-ml-sm">Tải dữ liệu</span>
          </q-card-section>
          <q-card-section class="row items-center">
            <input type="file" ref="upload" style="display:block" v-on:input="chooseFile" :accept="acceptFileType.join(',')"/>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="upload"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
const XlsxPopulate = require('xlsx-populate')
export default {
  props: {
    id: String,
    mode: String
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data() {
    return {
      pagination: {
        rowsPerPage:0,
        sortBy: 'lot',
        descending: true,
      },
      initFarm: null,
      datePopUp: false,
      farmPopUp: false,
      model: {},
      uploadData: [],
      dialogExit: false,
      dialogEdit: false,
      dialogDel: false,
      dialogSubmit: false,
      dialogUpload: false,
      pageLoad: false,
      tableKey: 0,
      dialogKey: 1,
      modelKey: 2,
      slotKey: 3,
      load : false,
      jobOptions: [],
      jobs: [],
      reports: {},
      ck: false,
      cn: false,
      modelForShow: {
      },
      acceptFileType: [
        '.xls',
        '.xlsx',
        '.csv',
      ],
      job: null,
      isAdding: false,
      location: {},
      selectedRowIndex: -1,
      workerTypes: [
        {
          label: 'Công nhật',
          value: 'congnhat',
          id: 'congnhat'
        },
        {
          label: 'Công khoán',
          value: 'khoan',
          id: 'khoan'
        }
      ],
      farms: [],
      headers: [{
          label: "No",
          align: "left",
          name: "no",
          field: "no"
        },
        {
        label: "Lô",
        align: "center",
        field: "lot",
        name: "lot",
        sortable: true,
        },
        {
        label: "Ô",
        align: "center",
        field: "slot",
        name: "slot",
        },
        {
        label: "Nội dung CV",
        align: "center",
        field: "job",
        name: "job",
        },
        {
        label: "Loại nhân công",
        align: "center",
        field: "jobType",
        name: "jobType",
        },
        {
        label: "Số lượng (công)",
        align: "center",
        field: "numOfTask",
        name: "numOfTask",
        },
        {
        label: "Định mức (Công/ Ngày)",
        align: "center",
        field: "quotaTask",
        name: "quotaTask",
        },
        {
        label: "Khối lượng kế hoạch",
        align: "center",
        field: "planWeight",
        name: "planWeight",
        },
        {
        label: "Đơn vị tính",
        align: "center",
        field: "unit",
        name: "unit",
        },
        {
        label: "Ghi chú",
        align: "center",
        field: "note",
        name: "note",
        }],
      csvFields: [
        {
        label: 'STT',
        },
        {
        label: 'Nông trường',
        value: 'farm'
        },
        {
        label: 'Lô',
        value: 'listPlan.lotID',
        key: 'lotID',
        type: 'number',
        required: true
        },
        {
        label: 'Ô',
        value: 'listPlan.slots',
        key: 'slots',
        type: 'array',
        },
        {
        label: 'Mã CV',
        value: 'listPlan.jobID',
        key: 'jobID',
        required: true,
        type: {
          showLabel: 'jobCode',
          listToFind: 'vm.jobStore.list'
          }
        },
        {
        label: 'Hạng mục công việc',
        value: 'listPlan.jobName',
        },
        {
        label: 'Loại',
        value: 'listPlan.jobType',
        key: 'jobType',
        required: true,
        type: {
          showLabel: 'label',
          listToFind: 'vm.workerTypes'
          }
        },
        {
        label: 'Số lượng (công)',
        value: 'listPlan.numOfTask',
        key: 'numOfTask',
        type: 'number',
        required: true
        },
        {
        label: 'Định mức (Công/ngày)',
        value: 'listPlan.quotaTask',
        key: 'quotaTask',
        type: 'number',
        required: true
        },
        {
        label: 'Khối lượng kế hoạch',
        value: 'listPlan.planWeight',
        key: 'planWeight',
        type: 'number',
        required: true
        },
        {
        label: 'ĐVT',
        value: 'listPlan.unit',
        },
        {
        label: 'Ghi chú',
        value: 'listPlan.note',
        key: 'note'
        }
      ]
    }
  },
  async mounted() {
    let vm = this
    try {
      if (vm._.find(vm.permission, {SUPVR: true}))
        throw Error("You don't have permission")
      vm.loading(true)
      vm.$nextTick(() => {
        vm.$refs.bar.start()
      })
      let f = vm.farmStore
      let j = vm.jobStore
      let m = vm.mekaStore
      let r
      vm.modelForShow = vm.initModelForShow()
      if (vm.id && vm.mode !== 'CREATE') {
        r = this.$query(['Plans', vm.id])
        vm.modelForShow.farm = vm.id
      }
      Promise.all([f, j, m, r]).then(res => {
        vm.farms = res[0].list
        vm.jobs = res[1].list.filter(item => item.deleted===false).sort((a, b) => a.name.localeCompare(b.name))
        vm.mekas = res[2].list.sort((a, b) => a.displayName.localeCompare(b.displayName))

        if (vm.mode === 'CREATE' || !vm.id) {
          vm.farmPopUp = true
        }
        else {
          vm.reports = res[3]
          vm.modelForShow = vm._.cloneDeep(res[3]) ? vm._.cloneDeep(res[3]) : {}
        }
      
        vm.pageLoad = true
        vm.$refs.bar ? vm.$refs.bar.stop() : null
      })
    } catch (error) {
      vm.$refs.bar ? vm.$refs.bar.stop() : null
      vm.$q.notify({
        message: error.message,
        color: 'red',
        icon: 'error'
      })
    }
    vm.loading(false)
  },
  computed: {
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'farmStore',
      'mekaStore',
      'jobStore'
    ]),
    lots: function () {
      let vm = this
      let lots = vm.modelForShow.farm ? this.$getNameById(vm.farms, vm.modelForShow.farm, 'listLot') : []
      return lots ? lots : []
    },
    slots: function() {
      let vm = this
      let slots = vm.modelForShow.lot ? vm.modelForShow.lot.listSlot : []//this.$getNameById(vm.lots, vm.modelForShow.lot, 'listSlot') : []
      for (let i in slots) {
        slots[i].picked = false
      }
      vm.modelKey++
      return slots
    },
    tableData: function() {
      let vm = this
      vm.tableKey
      let findObj = {
        lotID : vm.modelForShow.lot ? vm.modelForShow.lot.id : null,
        slots : vm.modelForShow.slot,
        jobID : vm.job,
      }

      Object.keys(findObj).forEach(key => findObj[key] === undefined || findObj[key] === null ? delete findObj[key] : '')
      let data  = vm._.cloneDeep(vm.modelForShow.listPlan)
      data = vm.modelForShow &&
        data ? data.filter(v => {
          return vm.sameType(v) && (!vm._.isEmpty(findObj) ? vm._.isMatch(v,findObj) : true)
          })
        : data
        return data.sort((a,b) => a.lotID > b.lotID ? 1 : a.lotID == b.lotID ? 0 : -1)
    }
  },
  watch: {
    'model.lotID' : function() {
      let vm = this
      //init slots
        let tmpSlots = vm.model.lotID ? vm._.cloneDeep(vm.$getNameById(vm.lots, vm.model.lotID.id ? vm.model.lotID.id : vm.model.lotID, 'listSlot')) : []

        for (let i in tmpSlots) {
          tmpSlots[i].picked = tmpSlots[i].picked ? tmpSlots[i].picked : false
        }

        for (let i in vm.model.slots) {
  
          let iden = (typeof vm.model.slots[i] === 'number') ? vm.model.slots[i] : vm.model.slots[i].id
  
          let findInModel = vm._.findIndex(tmpSlots, {id:iden})
          if (findInModel > -1 ) {
            tmpSlots[findInModel].picked = (typeof vm.model.slots[i] === 'number') ? true : false
          }
        }
        this.model.slots = vm._.cloneDeep(tmpSlots)
    }
  },
  methods: {
    loading(isLoad) {
      this.load = isLoad
    },
    genNextTag(format) {
      let now = moment.utc()
      if(now.date() <= 15) {
        now.date(16)
      } else {
        now.startOf('month').add(1, 'month')
      }
      if (this._.isEqual(format,'ky')) return `${now.date() <= 15 ? 'A' : 'B'}`
      return `${now.format(format)}`
    },
    async download() {
      let vm = this
      let model= []

      //fields that need to convert
      let idFields = [
        {
          key:'lotID',
        },
        {
          key:'slots',
        },
        {
          key:'jobID',
          label:'jobID',
          list: vm.jobs,
          name: 'jobCode'
        },
        {
          key:'jobID',
          label:'jobName',
          list: vm.jobs,
          name: 'name'
        },
        {
          key:'jobType',
          label:'jobType',
          list: vm.workerTypes,
          name: 'label'
        },
        {
          key:'numOfTask',
        },
        {
          key:'quotaTask',
        },
        {
          key:'planWeight',
        },
        {
          key:'jobID',
          list: vm.jobs,
          name: 'unit'
        },
        {
          key:'note',
        },
        ]

      //convert showing data to array
      //Plans worksheet
      model.push(vm._.map(vm.csvFields, 'label'))
      for (let i in vm.modelForShow.listPlan) {
        let row = [i]
        //add a row
        row.push(vm.$getNameById(vm.farms, vm.modelForShow.farm, 'name'))
        for (let f in idFields) {
          let id = vm.modelForShow.listPlan[i][idFields[f].key]
          let list = idFields[f].list
          let name = idFields[f].name
          // let label = idFields[f].label
          row.push(list ? vm.$getNameById(list, id, name) : (id instanceof Object) ? (JSON.stringify(id)).substr(1,JSON.stringify(id).length-2) : id)
        }
        model.push(row)
      }

      let colWidth = [
        [
          {col: 'A', wpx:10}, //stt
          {col: 'B',wpx:20},//nt
          {col: 'C',wpx:10}, //lo
          {col: 'D',wpx:50}, //o
          {col: 'E',wpx:30},// ma cv
          {col: 'F',wpx:30},//ten cv
          {col: 'G',wpx:20},//loai
          {col: 'H',wpx:20},// sl
          {col: 'I',wpx:20},// dm
          {col: 'J',wpx:25},//kl
          {col: 'K',wpx:20},//dvt
          {col: 'L',wpx:20},//note
        ],
        [
          {col: 'A',wpx:10},
          {col: 'B',wpx:30},
          {col: 'C',wpx:30},
          {col: 'D',wpx:20},
        ]
      ]

      //Jobs worksheet
      let jobs = [['STT','Mã CV','Hạng mục công việc','Đơn vị']]
      for (let i in vm.jobs) {
        let row = [i]
        row.push(vm.jobs[i].jobCode)
        row.push(vm.jobs[i].name)
        row.push(vm.jobs[i].unit)
        jobs.push(row)
      }


      let ext = 'xlsx'
      //Generate a file name
      let fileName = vm.$getNameById(vm.farms,vm.modelForShow.farm,'name') + '-' +(vm.modelForShow.tag ? vm.modelForShow.tag : vm.genNextTag('YYYY')+vm.genNextTag('MM')+vm.genNextTag('ky'))
      //generate workbook n worksheet

      XlsxPopulate.fromBlankAsync().then(workbook => {
                workbook.sheet(0).cell("A1").value(model)
                workbook.sheet(0).name(fileName).row(1).style("bold", true)
                workbook.addSheet("DS công việc")
                workbook.sheet(1).cell("A1").value(jobs)
                workbook.sheet(1).name("DS công việc").row(1).style("bold", true)
                for (let i in workbook.sheets()) {
                  for (let j in colWidth[i]) {
                    workbook.sheets()[i].column(colWidth[i][j].col).width(colWidth[i][j].wpx)
                  }
                }
                return workbook.outputAsync()
      }).then(blob => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, `${fileName}.${ext}`);
                } else {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = `${fileName}.${ext}`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }
      }).catch(err => {
        throw err
      })
    },
    upload() {
      let vm = this
      let data = []
      if (!vm.uploadData) return

      let rowData = {}
      try {

      //validate on headers
      if (!vm.validateUploadKeys(vm.uploadData[0])) {
        throw new Error('Dữ liệu cột không đúng')
      }
      vm.uploadData.forEach(row => {
      //maping uploadData label with csvFields key
          rowData = {}
        vm.csvFields.forEach(field => {
            if (field.key) {
              //if field value itself
              if (!field.type) {
                rowData[field.key] = row[field.label]
              }
              else {
                let f = null
                try {
                  //if field value is a number
                  if (field.type === 'number') {
                    // let regex = '^[a-zA-Z]*$'
                    if (typeof row[field.label] === 'number') f = row[field.label]
                    else if (!vm._.isEqual(row[field.label], '') && (row[field.label] !== null || row[field.label] !== undefined))//!row[field.label].matches(regex)
                      f = parseFloat(row[field.label])
                    else throw new Error(`${field.label} ${row[field.label] ? (row[field.label]) : 'Giá trị rỗng'}`)
                  }

                  //if field value is an array
                  else if (field.type === 'array') {
                      f = row[field.label] ? JSON.parse('['+row[field.label]+']') : []
                  }

                  //if field value is an object
                  else if (vm._.isEqual(typeof field.type, 'object')) {
                    f = vm._.find(eval(field.type.listToFind),{[field.type.showLabel]:row[field.label]}).id
                  }

                  //assign f for rowdata 
                  rowData[field.key] = f
                  
                }
                catch (err) {
                  //if parsing error
                  throw new Error(`${field.label} ${row[field.label] ? row[field.label] : 'Giá trị rỗng'}`)
                }
              }
            //if required field is empty
            if (field.required && (rowData[field.key] === null || rowData[field.key] === undefined)) {
              throw new Error(`${field.label} ${row[field.label] ? row[field.label] : 'Giá trị rỗng'}`)
            }
          }
        })

        //validate on lots
        if (rowData && vm.$getNameById(vm.lots, rowData.lotID, 'name') && vm.validateUploadData(rowData, data)) 
        {
          //add all slots if empty
          if (vm._.isEmpty(rowData.slots)) {
            rowData.slots = vm._.map(vm.$getNameById(vm.lots, rowData.lotID, 'listSlot'), 'id')
          }
          data.push(rowData)
        }
      });
      //last check if all upload data is valid
      if (vm.uploadData.length === data.length) {
        vm.modelForShow.listPlan = data
        vm.$q.notify({
          message: 'Tải dữ liệu thành công',
          color: 'green',
          icon: 'done'
        })
      }
      else throw new Error('unknown error')
        }
        catch (err) {
          vm.$q.notify({
            message: 'Không thể tải: ' + err.message,
            color: 'red',
            icon: 'error'
          })
        }
    },
    chooseFile(event) {
      let vm = this
      try {
        let input = event.target
        let reader = new FileReader()
        reader.onload = function() {
          let fileData = reader.result
          let wb = XLSX.read(fileData, {type : 'binary'})
          let rowObj = XLSX.utils.sheet_to_row_object_array(wb.Sheets[wb.SheetNames[0]])
          vm.uploadData = rowObj
        }
        reader.readAsBinaryString(input.files[0])
      }
      catch(err) {
        vm.uploadData = null
      }
    },
    validateUploadKeys(row) {
      let vm = this
      let valid = true
      vm.csvFields.forEach(field => {
        //if field has key then add it
        if(field.key) {
          if (field.required) {
            if (!row[field.label] || row[field.label] == undefined) {
              valid = false
              }
          }
        }
      })
      return valid
    },
    validateUploadData(rowData, data) {

      let vm = this
      let find

      if (!rowData.jobID || !rowData.lotID || !rowData.jobType) return false
      find = vm._.find(data, {
        jobID: rowData.jobID,
        lotID: rowData.lotID,
        jobType: rowData.jobType,
      })

      //validate duplicate data
      if (find) {

        throw new Error(`Trường dữ liệu trùng  Lô ${rowData.lotID} ô ${rowData.slots} công việc ${vm.$getNameById(vm.jobs,rowData.jobID,'name')}`)
      }

      //validate invalid slot
      //if there has slots input
      if(rowData.slots) {
        for (let i in rowData.slots) {
          find = vm._.find(vm.$getNameById(vm.lots,parseInt(rowData.lotID),'listSlot'), {id:rowData.slots[i]})
          if (!find) {
            throw new Error(`Không có dữ liệu Lô ${rowData.lotID} ô ${rowData.slots[i]} `)
          }
        }
      }

      return true
    },
    getJobs() {
      return this.jobs
    },
    // eslint-disable-next-line
    filterJob(val, update, abort) {
      let vm = this
      update(() => {
        if (val === '') {
          this.jobOptions = vm.jobs.filter(item => item.deleted===false)
        }
        else {
          const needle = val.toLowerCase()
          this.jobOptions = vm.jobs.filter(v => (
            (v.deleted===false &&
              (v.name && v.name.toLowerCase().indexOf(needle) > -1) ||
              (v.jobCode && v.jobCode.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1)
            )))
        }
      })
    },
    addItem() {
      this.resetData()
      this.isAdding = true
      this.dialogEdit = true
      this.$nextTick(() => {
        this.dialogKey++
      })
    },
    clickEditButton (props) {
      let vm = this
      vm.dialogEdit = true
      vm.selectedRowIndex = vm._.findIndex(vm._.cloneDeep(vm.modelForShow.listPlan),vm._.omit(props.row, '__index'))
      vm.model = vm._.cloneDeep(vm.modelForShow.listPlan[vm.selectedRowIndex])
      
      //init slots
      let tmpSlots = vm._.cloneDeep(vm.$getNameById(vm.lots, vm.modelForShow.lot, 'listSlot'))

      for (let i in tmpSlots) {
        tmpSlots[i].picked = tmpSlots[i].picked ? tmpSlots[i].picked : false
      }

      for (let i in vm.model.slots) {

        let iden = (typeof vm.model.slots[i] === 'number') ? vm.model.slots[i] : vm.model.slots[i].id

        let findInModel = vm._.findIndex(tmpSlots, {id:iden})
        if (findInModel > -1 ) {
          tmpSlots[findInModel].picked = (typeof vm.model.slots[i] === 'number') ? true : false
        }
      }

      vm.$nextTick(() => {
        vm.dialogKey ++
      })

    },
    validate() {
      let vm = this
      vm.$refs.lot.$emit('submitEvent', vm.model.lot)
      vm.$refs.job.$emit('submitEvent', vm.model.job)
      vm.$refs.numOfTask.$emit('submitEvent', vm.model.numOfTask)
      vm.$refs.planWeight.$emit('submitEvent', vm.model.planWeight)
      vm.$refs.quotaTask.$emit('submitEvent', vm.model.quotaTask)
      return (vm.errors.has('lot')||vm.errors.has('job')||vm.errors.has('numOfTask')||vm.errors.has('planWeight')||vm.errors.has('quotaTask'))
    },
    submitModel() {
      let vm = this
      vm.validate()
      vm.$nextTick(()=> {
        if (!vm.validate()) {
          if (vm.isCreatedField(vm.model)) {
            vm.$q.notify({
              message: 'Lưu thất bại: Trường dữ liệu trùng hoặc không phù hợp',
                color: 'red',
                icon: 'error'
              })
              
          }
          else {
            vm.model.slots = vm._.cloneDeep(vm.filterSlot(vm.model.slots))
            if (vm.isAdding) vm.modelForShow.listPlan.push(vm._.omit(vm._.cloneDeep(vm.model), '__index'))
            else vm.modelForShow.listPlan[vm.selectedRowIndex] = vm._.cloneDeep(vm._.omit(vm.model, '__index'))
  
            vm.tableKey++
            vm.dialogEdit = false
            vm.resetData()
          }
          return
        }
        vm.$q.notify({
          message: 'Vui lòng thử lại',
          color: 'red',
          icon: 'error'
        })
      })
    },
    deleteItem() {
      let vm = this
      vm.modelForShow.listPlan[vm.selectedRowIndex].deleted = true
      vm.dialogDel = false
      vm.dialogEdit = false
      vm.resetData()
      vm.tableKey ++
    },
    resetData() {
      this.isAdding = false
      this.model = {
        deleted: false,
        jobType: 'congnhat'
      }
    },
    submitData() {
      let vm = this
      vm.loading(true)
      let submitModel = { id: vm.id, data: vm._.cloneDeep(vm.modelForShow)}
      vm.$command.execute('updatePlans', submitModel).then( () => {
        vm.loading(false)
        vm.$q.notify({
          message: 'Đã lưu thành công',
          color: 'black',
          icon: 'check'
        })
        if (vm.mode === 'CREATE' || !vm.id) {
          vm.$router.push('/plans')
        }
      },  { mode: 'no-cors'} ).catch((error) => {
        vm.loading(false)
        console.log(error)
        vm.$q.notify({
          message: 'Lưu thất bại: ' + error.message,
          color: 'red',
          icon: 'error'
        })
      })
    },
    initModelForShow() {
      return {
        listPlan: [],
        farm: null,
      }
    },
    filterSlot(slots) {
      let filteredSlot = []
      let all = []
      for (let index in slots) {
        if (typeof slots[index] === 'number')
          {
            filteredSlot.push(slots[index])
            all.push(slots[index])
          }
        if (typeof slots[index] === 'object')
        {
          if(slots[index].picked !== false)
          {
            filteredSlot.push(slots[index].id)
          }
            all.push(slots[index].id)
        }
      }
      return !this._.isEmpty(filteredSlot) ? filteredSlot : all
    },
    applyFarm() {
      let vm = this
      vm.$refs.farm.$emit('submitEvent', this.initFarm)
      vm.$nextTick(() => {
        if (!vm.errors.has('farm')) {
             this.modelForShow.farm = this.initFarm
             this.farmPopUp = false
        }
        else {
            vm.$q.notify({
              message: 'Vui lòng thử lại',
              color: 'red',
              icon: 'error'
            })
          }
      })
    },
    sameType(item) {
      let vm = this
      return vm.ck == vm.cn ? true : vm.cn ? item.jobType === vm.workerTypes[0].id
      : item.jobType === vm.workerTypes[1].id //type = cn
    },
    isCreatedField(field) {
      let data = {
        deleted: false,
        jobID: field.jobID,
        lotID: field.lotID,
        jobType: field.jobType,
      }
      Object.keys(data).forEach(key => data[key] === undefined || data[key] === null ? delete data[key] : '')
      for (let i in this.modelForShow.listPlan) {
        if (i != this.selectedRowIndex && this._.isMatch(this.modelForShow.listPlan[i], data) ) return true
      }
      return false
    }

  }
}
</script>

